import axios from 'axios';

const baseURL = process.env.NODE_ENV === 'production'
    ? 'http://147.79.74.253'  // Use direct IP for now
    : process.env.REACT_APP_API_URL || 'http://localhost:5001';

console.log('Initializing axios with baseURL:', baseURL);

const instance = axios.create({
    baseURL,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Request interceptor
instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        
        if (config.url) {
            // Remove any leading slashes and clean up the URL
            const cleanUrl = config.url.replace(/^\/+/, '').replace(/\/+/g, '/');
            
            // Add back the api prefix
            if (!cleanUrl.startsWith('api/')) {
                config.url = `api/${cleanUrl}`;
            } else {
                config.url = cleanUrl;
            }
            
            console.log('Making request to:', `${config.baseURL}/${config.url}`);
        }

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    error => Promise.reject(error)
);

// Response interceptor
instance.interceptors.response.use(
    response => response,
    error => {
        console.error('API Error:', {
            url: error.config?.url,
            message: error.message,
            status: error.response?.status,
            data: error.response?.data
        });

        if (error.response?.status === 401 && !window.location.pathname.includes('/login')) {
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default instance; 